// src/prompts/router.js — First-pass pathology identification
// Returns pathologyId + whether additional input is needed

export const ROUTER_PROMPT = `Look at this concrete image and identify the primary visible pathology.

Choose from these 9 options:
p01_cracks         → Structural cracks (diagonal, horizontal, vertical, map cracking)
p02_spalling       → Spalling / surface breakout / exposed aggregate
p03_delamination   → Delamination / subsurface voids (needs percussion test)
p04_efflorescence  → White staining / efflorescence / calcium deposits
p05_popout_asr     → Pop-outs / alkali-silica reaction craters
p06_joints         → Damaged, missing, or deteriorated joint sealant
p07_corrosion      → Rebar corrosion / rust staining / longitudinal cracks
p08_plastic_shrinkage → Plastic shrinkage / early-age cracking
p09_carbonation    → Carbonation (needs pH/phenolphthalein test)
unidentifiable     → Cannot determine from image

Return ONLY this JSON (no other text):
{
  "pathology_id": "string",
  "confidence": 75,
  "requires_additional_input": false,
  "note": {
    "es": "brief note in Spanish about what is visible",
    "en": "brief note in English about what is visible"
  }
}`;
